<template>
  <div class="flex gap-6">
    <WarningDisable permission="process" />
    <div class="grow">
      <div class="mb-2 flex items-baseline justify-between">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Lịch sử quét
        </div>
        <ConfirmCreate />
      </div>
      <Loading v-if="action_store.loading.get_action_history" />
      <div v-else-if="action_store.total_filter > 0" class="overflow-x-auto">
        <table class="table-pin-rows table-md mb-4 table">
          <thead>
            <tr>
              <th></th>
              <th>Định danh</th>
              <th>Trạng thái</th>
              <th>Thời gian tạo</th>
            </tr>
          </thead>
          <tbody class="bg-base-200">
            <tr
              v-for="(action, idx) in action_store.actions"
              :key="action.id"
              @click="
                $router.push({
                  name: 'ClientProcessScanDetail',
                  params: {
                    action_id: action.id,
                  },
                })
              "
            >
              <th>
                {{
                  idx +
                  1 +
                  (number_from_query("page", 1) - 1) *
                    number_from_query("size", 24)
                }}
              </th>
              <td>{{ action.id }}</td>
              <td><ActionStatusBadge :status="action.status" /></td>
              <td>{{ dayjs(action.created).fromNow() }}</td>
            </tr>
          </tbody>
        </table>
        <Pagination :total_pages="action_store.total_pages" />
      </div>
      <NotFound v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query } from "@/api";
import ActionStatusBadge from "@/components/ActionStatusBadge.vue";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import dayjs from "dayjs";
import { onMounted } from "vue";
import { use_action } from "../ExplorerV2/useAction";
import WarningDisable from "../WarningDisable.vue";
import ConfirmCreate from "./ConfirmCreate.vue";

const action_store = use_action();
onMounted(() => {
  action_store.get_action_history({
    type: "process",
    action: "scan",
  });
});
</script>
